document.addEventListener('DOMContentLoaded', function() {
    
    HTMLElement.prototype.slideToggle = function(duration, callback) {
        if (this.clientHeight === 0) {
            _s(this, duration, callback, true);
        } else {
            _s(this, duration, callback);
        }
    };
    
    HTMLElement.prototype.slideUp = function(duration, callback) {
        _s(this, duration, callback);
    };
    
    HTMLElement.prototype.slideDown = function (duration, callback) {
        _s(this, duration, callback, true);
    };
    
    function _s(el, duration, callback, isDown) {
        
        if (typeof duration === 'undefined') duration = 400;
        if (typeof isDown === 'undefined') isDown = false;
        
        el.style.overflow = "hidden";
        if (isDown) el.style.display = "block";
        
        var elStyles        = window.getComputedStyle(el);
        
        var elHeight        = parseFloat(elStyles.getPropertyValue('height'));
        var elPaddingTop    = parseFloat(elStyles.getPropertyValue('padding-top'));
        var elPaddingBottom = parseFloat(elStyles.getPropertyValue('padding-bottom'));
        var elMarginTop     = parseFloat(elStyles.getPropertyValue('margin-top'));
        var elMarginBottom  = parseFloat(elStyles.getPropertyValue('margin-bottom'));
        
        var stepHeight        = elHeight        / duration;
        var stepPaddingTop    = elPaddingTop    / duration;
        var stepPaddingBottom = elPaddingBottom / duration;
        var stepMarginTop     = elMarginTop     / duration;
        var stepMarginBottom  = elMarginBottom  / duration;
        
        var start;
        
        function step(timestamp) {
            
            if (start === undefined) start = timestamp;
            
            var elapsed = timestamp - start;
            
            if (isDown) {
                el.style.height        = (stepHeight        * elapsed) + "px";
                el.style.paddingTop    = (stepPaddingTop    * elapsed) + "px";
                el.style.paddingBottom = (stepPaddingBottom * elapsed) + "px";
                el.style.marginTop     = (stepMarginTop     * elapsed) + "px";
                el.style.marginBottom  = (stepMarginBottom  * elapsed) + "px";
            } else {
                el.style.height        = elHeight        - (stepHeight        * elapsed) + "px";
                el.style.paddingTop    = elPaddingTop    - (stepPaddingTop    * elapsed) + "px";
                el.style.paddingBottom = elPaddingBottom - (stepPaddingBottom * elapsed) + "px";
                el.style.marginTop     = elMarginTop     - (stepMarginTop     * elapsed) + "px";
                el.style.marginBottom  = elMarginBottom  - (stepMarginBottom  * elapsed) + "px";
            }
            
            if (elapsed >= duration) {
                el.style.height        = "";
                el.style.paddingTop    = "";
                el.style.paddingBottom = "";
                el.style.marginTop     = "";
                el.style.marginBottom  = "";
                el.style.overflow      = "";
                if (!isDown) el.style.display = "none";
                if (typeof callback === 'function') callback();
            } else {
                window.requestAnimationFrame(step);
            }
        }
        
        window.requestAnimationFrame(step);
    }    
});

if (!customElements.get('tabs-section')) {
    customElements.define('tabs-section', class TabsSection extends HTMLElement {
        constructor() {
            super();
            
            this.initializeTab(this);
            this.initializeUnderline(this);
            this.initializeInnerCollapsiblesForTab(this);
            this.setBackgroundColorForActiveTab(this);
        }
        
        initializeUnderline(section) {
            let underline = document.createElement("div");
            underline.classList.add("underline");
            section.querySelector(".sustainability.tabs").appendChild(underline);
            
            section.updateUnderline(section);
        }
        
        updateUnderline(section) {
            section.querySelector('.underline').style.left = section.querySelector('.tab.active').offsetLeft + "px";
            section.querySelector('.underline').style.width = section.querySelector('.tab.active').offsetWidth + "px";
        }
        
        initializeTab(section) {
            section.querySelectorAll('.tab').forEach(function(tab) {
                tab.addEventListener('click', function() {
                    section.querySelectorAll('.tab').forEach(function(innerTab) {
                        innerTab.classList.remove('active');
                    });
                    section.querySelectorAll('.tab-content').forEach(content => {
                        content.style.display = 'none';
                    });                
                    tab.classList.add('active');
                    
                    section.setBackgroundColorForActiveTab(section);
                    
                    const targetContent = section.querySelector(tab.dataset.tabTarget);
                    targetContent.style.display = 'block';
                    
                    section.updateUnderline(section);
                });
            });
        }    
        
        initializeInnerCollapsiblesForTab(section) {
            const headers = section.querySelectorAll('.inner-collapsible-header');
            
            headers.forEach(header => {
                header.addEventListener('click', function() {
                    if (this.dataset.media !== '') {
                        this.closest('.collapsible-body').querySelector('.inner-collapsible-image').setAttribute('src', header.dataset.media);
                    }
                    const isOpened = this.parentElement.classList.contains('active');
                    this.closest('.inner-collapsible')?.querySelectorAll('.wrapper.active').forEach((wrapper)=> wrapper.classList.remove('active'));
                    if (!isOpened) {
                        this.parentElement.classList.add('active');
                    }
                });
            });
        }
        
        setBackgroundColorForActiveTab(section) {
            const activeTab = section.querySelector('.tab.active');
            const sustainabilityWrapper = section.querySelector('.sustainability-wrapper');
            const sectionWrapper = section.closest('.shopify-section');
            
            sustainabilityWrapper.style.background = "";
            sustainabilityWrapper.style.borderRadius = "";
            sustainabilityWrapper.style.padding = "";
            
            section.style.backgroundColor = "";
            sectionWrapper.style.backgroundColor = "";
            
            if (activeTab.dataset.background) {
                section.style.backgroundColor = activeTab.dataset.background;
                sectionWrapper.style.backgroundColor = activeTab.dataset.background;
            }
            
            if (activeTab.dataset.blockType === "boxed") {
                sustainabilityWrapper.style.background = "white";
                sustainabilityWrapper.style.borderRadius = "50px";
                sustainabilityWrapper.style.padding = "5px 40px";
            }
        }
    });
}
